import React from "react";
import { connect } from "react-redux";
import BackButton from "./BackButton";
import ToggleButton from "./ToggleButton";
import AddRule from "./AddRule";
import Modal from "./Modal";
import "assets/scss/styles.css";
import pencil from "assets/img/pencil.svg";
import close from "assets/img/close.svg";
class AddGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;
    let val = this.props.cust_tillSqlSelectionArr;
    let selectedDataNew = "";

    if (val.length > 0) {
      return (
        <React.Fragment>
          <div className="addgroupmain-wrap-c">
            <div
              className={val.length === 1 ? "addgroupmain-c" : "addgroupmain"}
            >
              {val.map((options, key) => (
                <div
                  key={key}
                  className={
                    val.length === 1 ? "addgrouplisting-d" : "addgrouplisting"
                  }
                  style={{ maxWidth: "100%" }}
                >
                  <div className="addgrouptitle topradius">
                    <div className="withoutbgbtngroup">
                      <a href="javascript:void(0)" className="withoutbgbtn">
                        <Modal
                          titleName="Add Rule"
                          buttonLabel="Add Rule"
                          selectedIndex={key}
                          selectedRule=""
                          mode="Create"
                          type="rule"
                          buttonType="add rule"
                          class="withoutbgbtn"
                        />
                      </a>
                      {/* <a href="javascript:void(0)" className="withoutbgbtn">
                        <Modal
                          buttonLabel="Add Group"
                          selectedIndex={key}
                          selectedRule=""
                          mode="Create"
                          type="group"
                          buttonType="add rule"
                          class="withoutbgbtn"
                        />
                      </a> */}
                    </div>
                  </div>
                  <div className="addgroupcontent">
                    {/* <ul className={val.length===1?"addrulelisting-c":"addrulelisting"}> */}
                    <AddRule key={key} selectedValue={options} index={key} />
                    {/* </ul> */}
                  </div>
                  <div className="andorbtngroupwrap parentwrap">
                    <div className="andorgroup">
                      {val.length > 0 && val.length - 1 != key ? (
                        <ToggleButton
                          selectedIndex={key}
                          selectedRule=""
                          type="Group"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <br />
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <AddRule key={0} selectedValue={[]} index={0} />
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  cust_count: state.cust_count,
  cust_tillSqlSelectionArr: state.cust_tillSqlSelectionArr,
  cust_afterSqlSelectionArr: state.cust_afterSqlSelectionArr,
  cust_groupLeveltoggle: state.cust_groupLeveltoggle,
  cust_ruleLeveltoggle: state.cust_ruleLeveltoggle,
  cust_isModalOpen: state.cust_isModalOpen,
});

export default connect(mapStateToProps)(AddGroup);



// WEBPACK FOOTER //
// ./src/views/Audiences/CCustomQueryBuilder/AddGroup.jsx